// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyAhG1jSEmwSohXD-6dQrKni9R4gH393JWk',
  authDomain: 'messenger5040.firebaseapp.com',
  projectId: 'messenger5040',
  storageBucket: 'messenger5040.appspot.com',
  messagingSenderId: '132278625039',
  appId: '1:132278625039:web:e1f07d2afa369f74c0547a',
  measurementId: 'G-8SP4BV4EK8',
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
